export default __webpack_public_path__ + "static/media/git.c2f5c09e.png";